module.exports = __webpack_public_path__ + "static/img/kup.914a206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/kup.png
// module id = vayi
// module chunks = 0